import { FC, useContext } from "react";
import { Box } from "@material-ui/core";
import { AccountCircleOutlined } from "@material-ui/icons";
import { usePostHog } from "posthog-js/react";

import { Button } from "components";
import { AppContext } from "contexts";
import { getCookie, navigateTo } from "lib/helpers";
import * as routes from "routes";
import { getPageURL } from "routes/config";
import { MenuItem, MenuItems } from "services/app/types";
import theme from "theme";
import { desktopHeaderHeight } from "theme/constants";

import HeaderItem from "./HeaderItem";

interface DesktopHeaderProps {
  isListings: boolean;
  menuItems: MenuItems;
  isLoggedIn: boolean;
  linkLogin: string;
  linkLogout: string;
  linkSignUp: string;
  hidden: boolean;
}

const DesktopHeader: FC<DesktopHeaderProps> = ({
  isListings,
  menuItems,
  isLoggedIn,
  linkLogin,
  linkLogout,
  linkSignUp,
  hidden,
}) => {
  const { user, domainNames } = useContext(AppContext);
  const posthog = usePostHog();
  const csrfToken = getCookie("csrftoken");

  return (
    <nav
      className={`nav es-nav-desktop -solid${hidden ? "" : " -open"}`}
      style={{
        transform: `translate3d(0px, ${
          hidden ? `-${desktopHeaderHeight}px` : "0px"
        }, 0px)`,
      }}
    >
      <div
        className={`${isListings ? "-container" : "orderbook-nav-container"}`}
      >
        <a href="/" className="-logo">
          {" "}
        </a>
        <div className="-links">
          <ul>
            {menuItems &&
              menuItems.topnav.map((menuItem: MenuItem, index: number) => (
                <HeaderItem
                  key={`${index}-${menuItem.name}`}
                  menuItem={menuItem}
                />
              ))}
          </ul>
          {isLoggedIn && (
            <div className="-meta -logged-in">
              <div className="-sub-nav">
                <span
                  id="id_account_control_button"
                  className="text -nav -light"
                >
                  <Box display="flex" alignItems="center">
                    <AccountCircleOutlined
                      fontSize="small"
                      style={{
                        marginRight: theme.spacing(0.5),
                        marginTop: theme.spacing(0.25),
                      }}
                    />
                    {user.dashboardName}{" "}
                    <i
                      className="fa fa-caret-down"
                      style={{ marginLeft: theme.spacing(0.5) }}
                    />
                  </Box>
                </span>
                <div className="-sub-links">
                  <ul>
                    <li>
                      <a
                        href={getPageURL(
                          routes.orderBookBuyerDashboard(),
                          domainNames,
                        )}
                        className="text -nav -dark"
                        id="id_dashboard_button"
                      >
                        Buyer Dashboard
                      </a>
                    </li>
                    <li>
                      <a
                        href={getPageURL(routes.sellerDashboard(), domainNames)}
                        className="text -nav -dark"
                        id="id_instant_valuation_button"
                      >
                        My Royalties
                      </a>
                    </li>
                    <li>
                      <a
                        href={getPageURL(
                          routes.orderBookOpenListings(user.userId),
                          domainNames,
                        )}
                        className="text -nav -dark"
                        id="id_live_orderbook_button"
                      >
                        The Exchange
                      </a>
                    </li>
                  </ul>
                  <ul className="-logout">
                    <li>
                      <a
                        href={getPageURL(
                          routes.directoryProfile(),
                          domainNames,
                        )}
                        className="text -nav -dark"
                        id="id_profile_button"
                      >
                        Edit Profile
                      </a>
                    </li>
                    <li>
                      <form method="post" action={linkLogout}>
                        <input
                          type="hidden"
                          name="csrfmiddlewaretoken"
                          value={csrfToken}
                        />
                        <button
                          id="id_signout_button"
                          className="text -nav -dark"
                          type="submit"
                          onClick={() => posthog?.reset()}
                        >
                          Log Out
                        </button>
                      </form>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
          {!isLoggedIn && (
            <>
              <ul className="-meta -logged-out">
                <li>
                  <a href={linkLogin} className="text -nav -light">
                    Sign In
                  </a>
                </li>
              </ul>
              <Button
                variant="contained"
                onClick={() => navigateTo(linkSignUp)}
                style={{
                  maxHeight: "40px",
                  marginLeft: "8px",
                  marginTop: "10px",
                }}
              >
                Join Now
              </Button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default DesktopHeader;
